export default "__VITE_ASSET__D3rF6cpm__"